"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.channels.title': 'Integrazioni canali',
    'socialMediaPlan.channels.desc': 'Connetti i tuoi account.',
};
